{
  "COMMON_REVIEW_CARD": {
    "COMMON": {
      "ACTION_LABELS": {
        "VIEW": "View",
        "CANCEL": "Cancel",
        "EDIT": "Edit",
        "SAVE": "Save",
        "RESPOND": "Respond",
        "RESPOND_ON_SOURCE": "Respond on {{ review_domain }}",
        "COPY_RESPONSE": "Copy response",
        "POST": "Post",
        "CLOSE": "Close",
        "RETRY": "Retry",
        "CONNECT": "Connect {{ source }}",
        "POST_RESPONSE": "Post Response",
        "GO_TO_SOURCE": "Go to source",
        "REQUEST_APPROVAL": "Request Approval"
      },
      "CONNECT_GMB": "Connect Google Business Profile",
      "CONNECT_FACEBOOK": "Connect Facebook"
    },
    "REVIEWS": {
      "MANAGE": {
        "CONCIERGE_RESPONSE": {
          "TITLE": "{{ agentName }} at {{ partnerName }} has submitted a review response for approval:",
          "FEEDBACK": "Thank you for providing Feedback:",
          "APPROVE_BUTTON": "Approve",
          "PROVIDE_FEEDBACK_BUTTON": "Provide Feedback",
          "SEND_FEEDBACK_BUTTON": "Send Feedback",
          "APPROVED_FEEDBACK": "Thank you. {{ partnerName }} will now publish the response on your behalf"
        },
        "REVIEW_CARD": {
          "TITLE": "{{reviewer_name}} reviewed your business on {{ review_domain }}",
          "SUBTITLE": {
            "EDITED": "edited"
          },
          "TIME_AGO_ON": "{{ timeAgo }} on",
          "RECOMMENDATION_TITLE": "recommends",
          "NOT_RECOMMENDATION_TITLE": "doesn't recommend",
          "YOUR_BUSINESS": "your business",
          "MY_LISTING_SOURCE_NAME": "My Listing",
          "SOURCE_NAME": {
            "GOOGLE": "Google",
            "FACEBOOK": "Facebook"
          },
          "RESPONSE_BOX": {
            "SUGGEST_RESPONSE": "Suggest response",
            "RESPOND_TOOLTIP": "Use a suggestion below to auto-populate a full response or type your reply here",
            "RESPOND_TOOLTIP_REVIEW_SITES": "Use a suggestion below to auto-populate a full response that you can copy and use to respond on the review website",
            "NO_TEMPLATE_RESPONSE_TOOLTIP": "Type your reply here",
            "FEEDBACK_TOOLTIP": "Provide Feedback",
            "HINT": "<b>Note:</b>&nbsp;An email response will be sent to the customer",
            "PLACEHOLDER_WARNING": "*Edit [placeholder text] before posting this response",
            "GOOGLE_USER_WARNING": "*Edit \"A Google User\" before posting this response",
            "ERROR_LOADING_TEMPLATE": "Template not found",
            "CONNECT_ACCOUNT": "Connect your account to respond to this review."
          },
          "CHIP_LABELS": {
            "ACTION_REQUIRED": "Response Required",
            "NO_ACTION_REQUIRED": "No Response Required",
            "RESPONDED": "Responded",
            "PUBLISHED": "Published",
            "AWAITING_APPROVAL": "Response Awaiting Approval",
            "RESPONSE_APPROVED": "Response Approved",
            "FEEDBACK_PROVIDED": "Feedback Provided",
            "OWNER_RESPONDED": "Owner Responded",
            "PARTNER_RESPONDED": "{{partnerName}} Responded",
            "FULFILLMENT_RESPONDED": "Fulfillment Team Responded"
          },
          "ACTIONS": {
            "SHARE_ON_SOCIAL": "Share on Social",
            "REVIEW_ON_SOURCE": "Review on {{ sourceName }}",
            "PUBLISH_TO_REVIEW_WIDGET": "Publish to Review Widget",
            "UNPUBLISH_FROM_REVIEW_WIDGET": "Unpublish from Review Widget",
            "PUBLISH_TO_MY_LISTING": "Publish to my listing",
            "UNPUBLISH_FROM_MY_LISTING": "Unpublish from My Listing",
            "VIEW": "View",
            "HIDE": "Hide",
            "COMMENT": "response",
            "COMMENTS": "responses"
          },
          "MESSAGES": {
            "RESPONSE_FROM": "Response from",
            "ERROR_ADDING_COMMENT": "Error adding comment",
            "COMMENT_SAVED": "Comment saved",
            "ERROR_EDITING_COMMENT": "Error editing comment",
            "COMMENT_EDITED": "Comment edited",
            "ERROR_PUBLISHING_REVIEW": "Error publishing review",
            "REVIEW_PUBLISHED": "Review published",
            "ERROR_UNPUBLISHING_REVIEW": "Error unpublishing review",
            "REVIEW_UNPUBLISHED": "Review unpublished",
            "ERROR_PUBLISHING_REVIEW_TO_WIDGET": "Error publishing review to widget",
            "REVIEW_PUBLISHED_TO_WIDGET": "Review published to widget",
            "ERROR_UNPUBLISHING_REVIEW_FROM_WIDGET": "Error unpublishing review from widget",
            "REVIEW_UNPUBLISHED_FROM_WIDGET": "Review unpublished from widget",
            "ERROR_UPDATING_REVIEW_STATUS": "Error updating review status",
            "REVIEW_STATUS_UPDATED": "Review status updated",
            "ERROR_ADDING_FEEDBACK": "Error adding Feedback",
            "FEEDBACK_SAVED": "Feedback Sent",
            "ERROR_APPROVING_FEEDBACK": "Error Approving Feedback",
            "RESPONSE_APPROVED": "Response Approved",
            "LAST_FAILED_REVIEW_COMMENT": "Sorry, your response failed to post.  Please try again.",
            "REVIEW_HAS_BEEN_DELETED": "Sorry, this review has been deleted",
            "REVIEW_RESPONSE_UPDATED": "Your review response was updated",
            "ERROR_SAVING_REVIEW_RESPONSE": "There was an error updating your review response. Copy your response, refresh the page, and try again.",
            "REVIEW_NO_LONGER_EXISTS": "The Review for this Task no longer exists",
            "ERROR_REQUESTING_APPROVAL": "There was an error requesting approval, please try again",
            "APPROVAL_REQUESTED": "Approval requested",
            "RESPONSE_COPIED": "Response copied",
            "FAIL_TO_COPY_RESPONSE": "Failed to copy the responsse"
          },
          "DELETED": {
            "INFO": "We suspect that this review was removed from {{source_name}}.",
            "NOTE": "<b>Note:</b>&nbsp;Removed reviews do not contribute to your average review rating. If you can no longer find this review on {{source_name}}, you can mark it as Removed.",
            "INFO_TOOLTIP": "Learn more",
            "CONFIRM_DELETED": "Mark as removed",
            "CONFIRM_NOT_DELETED": "Keep review",
            "ERROR_REMOVED": "Error marking review as Removed",
            "ERROR_KEPT": "Error marking review as Kept",
            "SUCCESSFULLY_REMOVED": "Review was marked as Removed",
            "SUCCESSFULLY_KEPT": "Review was marked as Kept"
          },
          "EDITED": "Edited"
        },
        "CONNECT_ACCOUNTS": {
          "CONNECT_GMB_TITLE": "Connect a Google Business Profile Account",
          "CONNECT_GMB_CONTENT_1": "You have not connected a Google Business Profile account. ",
          "CONNECT_GMB_CONTENT_2": "Please connect your account to reply to reviews on Google Maps.",
          "CONNECT_FACEBOOK_TITLE": "Connect a Facebook Account",
          "CONNECT_FACEBOOK_CONTENT_1": "You have not connected a Facebook account.",
          "CONNECT_FACEBOOK_CONTENT_2": "Please connect your account to reply to reviews on Facebook.",
          "NOT_CONNECTED": "{{source}} is not connected.",
          "GO_TO_RM_TO_CONNECT": "Go to Reputation Management to connect"
        }
      }
    },
    "CONTENT": {
      "MORE": "more"
    }
  },
  "REVIEW_HISTORY_CARD": {
    "TITLE": "Review history",
    "LIVE_BADGE": "Live",
    "EMPTY_STATE": {
      "TITLE": "No history available",
      "SUBTITLE": "We couldn't find a history of the edits to this review"
    }
  },
  "REVIEW_SOURCE_SELECTION": {
    "MESSAGES": {
      "ERROR_NO_SOURCE_SELECTED": "Please select at least one source.",
      "ERROR_SELECT_LESS_SOURCES_THAN_LIMIT": "Please select a maximum of {{maxSelections}} sources."
    }
  },
  "NPS_CARD": {
    "NPS_RESEND_CONFIRMATION": {
      "TITLE": "Are you sure you want to re-send an NPS request?",
      "RESEND_BUTTON": "Re-send",
      "EMAIL_NOT_FOUND": "Add an email to the contact to re-send NPS request."
    },
    "RESEND_REQUEST": "Once you’ve addressed their concerns, you could ask them for another review",
    "RESENT_REQUEST": "Customer was asked to review their experience again on {{resentDate}}",
    "RESEND_NPS_REQUEST": "Re-send NPS request"
  },
  "NPS_OVERALL_CHART": {
    "NAME": "Net Promoter Score (NPS)",
    "NPS_PROMOTER": "Promoter",
    "NPS_PASSIVE": "Passive",
    "NPS_DETRACTOR": "Detractor",
    "NPS_INFO": "Net Promoter Score (NPS) measures your customer satisfaction and loyalty.<br><br> <b>How it's calculated:</b> <br> NPS = % Promoters - % Detractors <br> <br> <b>Explanation:</b> <br> •Promoters: Customers who would recommend your brand. <br> •Detractors: Customers who wouldn't recommend your brand.<br><br> <b>Example:</b> <br> If 70% of your customers are promoters and 10% are detractors, your NPS is 60.",
    "RATINGS": "{{totalScore}} ratings"
  },
  "NPS_ROLLING_AVG_GRAPH": {
    "TITLE": "Score over time",
    "NPS_INFO": "The Net Promoter Score (NPS) shown here is calculated using a 30-day rolling window. This means the score is an average of the feedback received over the past 30 days, updated daily. This method helps smooth out short-term fluctuations and highlights longer-term trends in customer satisfaction."
  }
}
